/** @format */

import {Modal, ModalHeader, ModalFooter, Toast} from '@sttark/design-system';
import {useOrderArchive} from '../../shared/use_order_archive';
import React, {useEffect, useState} from 'react';
import {If, IfElse} from 'frontier-utilities';
import {Button} from '@sttark/design-system';

export const ArchiveOrder = ({order, onArchive}) => {
    const [toast, setToast] = useState({
        isDanger: false,
        isOpen: false,
        message: ''
    });

    const [showingModal, setShowingModal] = useState(false);

    const {handleArchive, isSaving, error} = useOrderArchive(order.id, () => onArchive(order.id));

    const hideToast = () => {
        setToast({
            isDanger: false,
            isOpen: false,
            message: ''
        });
    };

    useEffect(() => {
        if (error) {
            setToast({
                message: 'Error occurred while archiving the order. Please try again.',
                isDanger: true,
                isOpen: true
            });
        }
    }, [error]);

    return (
        <>
            <Toast
                danger={toast.isDanger}
                autoHideDuration={4000}
                isOpen={toast.isOpen}
                onClose={hideToast}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">{toast.message}</p>
            </Toast>
            <If condition={!order.is_archived}>
                <button
                    className="p-0 m-0 color-alert-negative d-flex align-items-center justify-content-start"
                    onClick={() => setShowingModal(true)}>
                    <i className="fa fa-trash me-2" />
                    <u>Archive order</u>
                </button>
            </If>
            <Modal isOpen={showingModal} onClose={() => setShowingModal(false)} bodyHeightAuto>
                <ModalHeader>Archive whole order</ModalHeader>
                <div>
                    <h5 style={{margin: '0 0 8px'}}>Archiving the whole order will:</h5>
                    <p className="m-0 p-0">
                        Remove this order from your past orders and archive all related designs. You
                        can un-archive it at any time from the archived tab.
                    </p>
                </div>
                <ModalFooter>
                    <IfElse condition={!isSaving}>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button
                                onClick={() => setShowingModal(false)}
                                label="Cancel"
                                secondary
                            />
                            <Button
                                onClick={handleArchive}
                                label="Archive Whole Order"
                                destructive
                            />
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-2">
                            <i className="fa fa-spinner fa-spin" />
                            <span>Archiving...</span>
                        </div>
                    </IfElse>
                </ModalFooter>
            </Modal>
        </>
    );
};
